import styled, { keyframes } from 'styled-components';
import { COLORS } from '../../styles/variables';

interface StyleProps {
  size: number | undefined;
}

const spin = keyframes`
  to { transform: rotate(360deg) }
`;

// eslint-disable-next-line import/prefer-default-export
export const StyledSpinner = styled.div`
  display: inline-block;
  width: ${({ size = 40 }: StyleProps) => `${size}px`};
  height: ${({ size = 40 }: StyleProps) => `${size}px`};
  border: 3px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top-color: ${COLORS.grey30};
  animation: ${spin} 1s ease-in-out infinite;
`;
